import {IntermediatePart} from "../../parts/intermediatePart";
import {Vanity} from "../../parts/vanity";
import DesignNavigationItem from "../../../../visComponents/designNavigationItem";
import uniqBy from "lodash/uniqBy";

export default class VanityCountertop extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = 'vanity_countertop';
    this.partName = 'Countertop';
    this.translateId = "visualizer.bathroom.vanity.vanity_countertop";
    this.homePageTitle = 'Countertops';
    this.visible = [Vanity.Types.Custom];
    this.isStoneFeature = true;
  }

  load(dbFeature) {
    return super.load_(dbFeature, new VanityCountertop())
  }

  disabledClick() {
    this.getParent().toggleVanityParts(this.disabled);
  }

  navigationSubItems(filters, searchText) {
    const filteredAvailableFeatures = super.getFeaturesBySearchText(super.getFilteredFeaturesByFilters(filters), searchText);
    // return super.navigationSubItemsWithFilter('CountertopSize', this.getParent().counterTopSize(), filteredAvailableFeatures);
    let counterTopsAvailable = filteredAvailableFeatures.filter(feature => {
      return feature.matchesMetaForCondition('CountertopSize', this.getParent().counterTopSize())
    })
    return uniqBy(counterTopsAvailable, (feature) => feature.dbFeature.id)
      .map(_ => new DesignNavigationItem(_.featureName, _));
  }

  setDefault(layout) {
    const counterTopSize = this.getParent().counterTopSize();
    const filteredFeatures = this.features && this.features.filter(f => f.matchesMetaForCondition('CountertopSize', counterTopSize)) || [];
    if (!super.tryToSetTheSameFeature(filteredFeatures)) {
      const hardCodedDefault = filteredFeatures.find((feature) => {
        return feature.dbFeature.displayName && feature.dbFeature.displayName.includes("Aliveri");
      });
      const placeholderDefault = filteredFeatures.find((feature) => {
        return feature.dbFeature.displayName && feature.dbFeature.displayName.includes("laceholder");
      });
      this.activeFeature = hardCodedDefault || super.setDefault(layout) || filteredFeatures[0];
      this.placeholderFeature = placeholderDefault || super.setDefault(layout) || null;
    }
  }

  setLayers(layout) {
    const counterTopSize = this.getParent().counterTopSize();
    if (this.activeFeature && (this.activeFeature.matchesMetaForCondition('CountertopSize', counterTopSize)
      || (this.activeFeature.notAvailableInVisualizer && this.placeholderFeature))) {
      return super.setLayers(layout);
    }

    this.setDefault(layout);
    return super.setLayers(layout);

  }

  setZIndex(zIndexes) {
    if (zIndexes && this.getParent().activeSubType_ === Vanity.Types.Custom) {
      if (this.activeFeature) {
        this.activeFeature.layer.zIndex = zIndexes.Vanity.Custom.CounterTop;
      }
      if(this.placeholderFeature) {
        this.placeholderFeature.layer.zIndex = zIndexes.Vanity.Custom.CounterTop;
      }
    }
  }
}
